/**
 * recordingRequestModalButtons.tsx
 */
import Container from '../../atoms/container/modalButtons';
import Direction from '@shared/types/enums/direction';
import EpgEvent from '@shared/classes/epgEvent';
import FastEvent from '@shared/classes/fastEvent';
import Focus from '@shared/types/enums/focus';
import List from '../../sections/list/list';
import Modals from '@shared/types/enums/modals';
import RecordType from '@shared/types/enums/recordType';
import { addRecordingRequest } from '@shared/api/recording/recordingsRequest';
import { clearModal, setModal } from '@shared/store/slices/modal.slice';
import { popFocus, pushFocus } from '@shared/store/slices/focus.slice';
import { reload } from '@shared/store/slices/floatingMenu.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useCallback, useEffect } from 'react';
import ModalButton from '../buttons/ui/modalButton';

export default function RecordingModalButtons({
  asset,
}: {
  asset?: EpgEvent | FastEvent;
}) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  const recordButtonAction = useCallback(
    async (type: number) => {
      if (asset) {
        addRecordingRequest(asset?.eventId, type)
          .then(() => dispatch(reload()))
          .catch((e) => {
            setTimeout(() => {
              if (e.error_code == '201') {
                dispatch(setModal(Modals.UPGRADE_RECORD_PLAN));
              } else {
                dispatch(clearModal());
              }
            });
          });
      }
      dispatch(clearModal());
    },
    [asset]
  );

  return (
    <Container>
      <List direction={Direction.VERTICAL} focus={Focus.MODAL_BUTTONS}>
        <ModalButton
          index={0}
          text={'MODAL.RECORDING.EPISODE'}
          releaseAction={() => recordButtonAction(RecordType.SHOW)}
        />
        <ModalButton
          index={1}
          text={'MODAL.RECORDING.SEASON'}
          releaseAction={() => recordButtonAction(RecordType.SEASON)}
        />
      </List>
    </Container>
  );
}
